import React from "react";
import { CheckCircleOutlined } from "@ant-design/icons";

function CompleteIcon() {
  return (
    <CheckCircleOutlined
      style={{
        color: "#52C41A",
      }}
    />
  );
}

export default CompleteIcon;
